import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { convertCurrency } from "enrollment/utils";
import { PsButtonTuner } from "stencilSetup";
import { AdjustContributionBannerStyles } from "./EditContributionDrawerStyled";
import { ScheduledContributionDto } from "enrollment/queries/useV3ContributionAmountQuery";

interface AdjustContributionProps {
    totalContribution: number;
    perPayPeriodContributionsUpdated: number;
    adjustContrubtionAmount: (adjustContribution: string, balanceContributionDollarAmount:number) => void;
    localScheduledContributions: ScheduledContributionDto[],
    initialTotalContributionAmount:number
}

export const AdjustContributionBanner = ({  totalContribution, adjustContrubtionAmount, perPayPeriodContributionsUpdated, localScheduledContributions, initialTotalContributionAmount }: AdjustContributionProps) => {
    const balanceContributionAmount = initialTotalContributionAmount - totalContribution;
    const balanceContributionDollarAmount = convertCurrency(JSON.stringify(balanceContributionAmount));
    const [adjustContributionBanner, setadjustContributionBanner] = useState(false);
    const { t } = useTranslation('pages.financial');

    useEffect(() => {
        if (!perPayPeriodContributionsUpdated || perPayPeriodContributionsUpdated === localScheduledContributions?.length) {
            setadjustContributionBanner(false);
        } else if (perPayPeriodContributionsUpdated) {
            setadjustContributionBanner(true);
        }
    }, [perPayPeriodContributionsUpdated, localScheduledContributions]);

    return (
        <>
            {adjustContributionBanner && (balanceContributionAmount > 0) && <div className="position-relative">
                <span className="position-absolute totalContributionIIcon text-center semiBold">i</span>
                <AdjustContributionBannerStyles >
                    <div>
                        <div className="py-2 adjustBannerText">{t('editContribution.contributionAmountChangeText')}</div>
                        <div className="py-2 title-small" data-testid="balContributionAmount">{t('editContribution.contributionAmountChangedAndBalance', { maxContribution: convertCurrency(JSON.stringify(initialTotalContributionAmount)), totalContribution: convertCurrency(JSON.stringify(totalContribution)), balanceContributionDollarAmount })} </div>
                        <div className="py-2 adjustBannerText">{t('editContribution.wouldYoulikeContribute', {balanceContributionDollarAmount})}</div>
                        <div className="d-flex">
                            <div className="mr-2">
                                <PsButtonTuner data-testid="adjust-balance-contribution" buttonId="adjustContributionBtnYes" label={t('editContribution.adjustContributionValuesYes')} level="tertiary" onClick={() => {
                                    adjustContrubtionAmount("yes", balanceContributionAmount);
                                    setadjustContributionBanner(false);
                                }}></PsButtonTuner>
                            </div>
                            <div>
                                <PsButtonTuner data-testid="do-not-adjust-balance-contribution" buttonId="adjustContributionBtnNo" label={t('editContribution.adjustContributionValuesNo')} level="tertiary" onClick={() => {
                                    adjustContrubtionAmount("no", 0);
                                    setadjustContributionBanner(false);
                                }}></PsButtonTuner>
                            </div>
                        </div>
                    </div>
                </AdjustContributionBannerStyles>
            </div>}
        </>
    );
};
